import { MessageCircle } from "lucide-react";
import { buildWhatsAppLink } from "@/lib/config";

export const WhatsAppButton = ({ message = "Hello Bawajii Travels, I would like to enquire about a booking." }) => {
  return (
    <a
      href={buildWhatsAppLink(message)}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp-btn"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 rounded-full bg-[#25D366] px-5 py-3 text-white font-medium shadow-2xl hover:bg-[#1ebe57] transition-colors duration-300"
    >
      <MessageCircle className="h-5 w-5" />
      <span className="hidden sm:inline">Chat on WhatsApp</span>
    </a>
  );
};

export default WhatsAppButton;
